import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { CallToActionBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { borderColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderColor";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  ContentProp,
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { salesPrimaryBlockDefaultStyles } from "../../Sales/constants";
import { CardCallToActionBlock as Block } from "./CardCallToActionBlock";
import { defaultData } from "./CardCallToActionDefaultData";
import imagePreview from "./card_call_to_action_preview.png";

export const CardCallToAction: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Card CTA",
    version: 1,
    nameI18n: "builder_ui.block_type.card_cta",
    isHidden: true,
    category: [CallToActionBlock],
    props: {
      highlight: {
        prop: "other",
        type: "string",
        name: "Highlight",
        nameI18n: "builder_ui.prop_type.highlight",
        category: [ContentProp],
      },
      content: {
        prop: "children",
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        type: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            category: [DesignProp, GeneralProp],
            defaultValue: salesPrimaryBlockDefaultStyles.backgroundColor,
          },
          padding: {
            ...padding,
            category: [DesignProp, PaddingsProp],
            defaultValue: salesPrimaryBlockDefaultStyles.padding,
          },
          margin: {
            ...margin,
            category: [DesignProp, MarginsProp],
            defaultValue: salesPrimaryBlockDefaultStyles.margin,
          },
          borderColor: {
            ...borderColor,
            category: [DesignProp, GeneralProp],
            defaultValue: "var(--theme-website-color-border-primary)",
          },
        },
      },
    },
  },
};
